import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
export default {
  currentProvider: function currentProvider(store) {
    var selectedProvider = {};

    if (store.managedProviders && store.managedProviders.data) {
      store.managedProviders.data.find(function (provider) {
        if (provider.id === store.selectedProvider) {
          selectedProvider = provider;
        }
      });
    }

    return selectedProvider;
  }
};